/**
 * Dashboard API
 * ─────────────
 * Returns aggregated dashboard data for the current user based on their role.
 * Backend computes everything (stats, charts, recent activity) in one call.
 */

import api from './axios';

export const dashboardApi = {
  // For admin users
  admin: () => api.get('/admin/dashboard'),

  // For client users
  client: () => api.get('/user/dashboard'),

  // For provider users
  provider: () => api.get('/provider/dashboard'),
};